import Alpine from "alpinejs";
import ui from "@alpinejs/ui";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import AutoAnimate from "@marcreichel/alpine-auto-animate";
import tooltip from "./tooltip.js";
import Typewriter from '@marcreichel/alpine-typewriter';
import { tns } from "tiny-slider/src/tiny-slider";
import scrollTo from 'alpinejs-scroll-to';



window.tns = tns

export default function() {
    window.Alpine = Alpine;
    Alpine.plugin(ui);
    Alpine.plugin(AutoAnimate);
    Alpine.plugin(intersect);
    Alpine.plugin(persist);
    Alpine.plugin(focus);
    Alpine.plugin(collapse);
    Alpine.plugin(Typewriter);
    Alpine.plugin(scrollTo);    
    Alpine.start();
    tooltip();
}